module.exports = __webpack_public_path__ + "static/fontello-bb50c937056a144587a79bf937ed7400.ttf";